import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed; 
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background-color: rgba(0, 0, 0, 0.7); 
  
  display: flex;
  justify-content: center;
  align-items: center;
  
  z-index: 1000; 
`;

export default function Modal({ isOpen, onClose, children }) {
  if (!isOpen) {
    return null;
  }

  const modalRoot = document.getElementById('modal-root');
  if (!modalRoot) {
    console.error("HTML에 'modal-root' ID를 가진 요소가 없습니다.");
    return null;
  }

  return ReactDOM.createPortal(
    <ModalOverlay onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()}> 
        {children}
      </div>
    </ModalOverlay>,
    modalRoot 
  );
}